export default __webpack_public_path__ + "static/media/wallet.20a5fee8.png";